var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M31.7,-45.9C41.6,-43,50.4,-35,61.3,-24.2C72.2,-13.3,85.2,0.4,81.7,10.5C78.3,20.5,58.3,26.9,45.7,37.2C33,47.4,27.6,61.6,17.2,69.6C6.8,77.6,-8.5,79.6,-17.9,71.9C-27.3,64.2,-30.8,46.9,-37.6,34.9C-44.4,22.8,-54.6,16.1,-58.4,6.8C-62.2,-2.4,-59.6,-14.2,-56.2,-27.3C-52.8,-40.4,-48.6,-54.8,-39.1,-57.9C-29.7,-60.9,-14.8,-52.6,-2,-49.6C10.9,-46.5,21.8,-48.8,31.7,-45.9Z",
    transform: "translate(100 100)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.b8628d56c589221d7e12d801bae6b59b.svg";
export { ForwardRef as ReactComponent };